module.exports = __webpack_public_path__ + "img/symbol_10.4b8622ed.png";